












































import { defineComponent, ref, PropType, computed, useFetch, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { SMARTPHONE } from '~/constants/breakpoint';
import { url } from '~/utils';
import { ProductShowECResponseSchema, ProducingAreaIntroSection } from '~/types/modules/product';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const { app } = useContext();
    const areaId = computed(() => props.ecResponse.master_settings?.producing_areas?.slice(-1)?.[0]?.id);
    const link = computed(
      () => areaId.value && { path: url('ITEM_LIST'), query: { _area: areaId.value, _qty: BooleanLike.TRUE } }
    );
    const data = ref<ProducingAreaIntroSection | null>(null);
    const isSmartPhone = ref(app.$ua.deviceType() === SMARTPHONE);

    useFetch(async () => {
      try {
        if (!areaId.value) {
          return;
        }
        const response = await store.dispatch('product/detail/fetchIntro', {
          q: `mst:producing_area AND producing_area_id_i:${areaId.value}`,
        });
        data.value = {
          image: response?.main_image_url_s,
          caption: response?.short_caption_t,
          description: response?.short_description_t,
        };
      } catch {
        // 何もしない
      }
    });

    const areaNames = computed(() => {
      const areas = props.ecResponse.master_settings?.producing_areas || [];
      const subAreaNames = areas.map((area) => area.name || '');
      const mainAreaName = subAreaNames.pop();
      return {
        mainAreaName,
        subAreaNames: subAreaNames.join(' '),
      };
    });

    const hasNoContent = computed(() => !data.value?.image && !data.value?.caption && !data.value?.description);

    return {
      link,
      data,
      areaNames,
      hasNoContent,
      isSmartPhone,
    };
  },
});
